<div class="row">
  <div class="col-md-12">
    {{ "GAME_TYPE" | translate }}
  </div>
  <div class="col-md-12">
     <div class="d-flex">
       <div>
         <div class="form-check form-check-inline">
           <input
             class="form-check-input"
             type="checkbox"
             name="inlineRadioOptions"
             id="flexCheckIndeterminate"
             [checked]="GameTypeSelect?.length == 0"
             (change)="GameTypeSelect = []; outputGameType()"
           />
           <label class="form-check-label" for="flexCheckIndeterminate">{{ "ALL" | translate }}</label>
         </div>
       </div>
       <div class="border-start ps-3">
         <div class="form-check form-check-inline" *ngFor="let data of constDataPreload?.game?.game_type">
           <input
             class="form-check-input"
             type="checkbox"
             name="inlineRadioOptions"
             id="{{ data }}"
             [checked]="GameTypeSelect.includes(data) && GameTypeSelect?.length != constDataPreload?.game?.game_type?.length"
             (change)="onSelectGameType(data)"
           />
           <label class="form-check-label" for="{{ data }}">{{ data.toUpperCase() | translate }}</label>
         </div>
       </div>
     </div>
  </div>
</div>
